import { render, staticRenderFns } from "./Entity.vue?vue&type=template&id=c31a5b10&scoped=true"
import script from "./Entity.vue?vue&type=script&lang=js"
export * from "./Entity.vue?vue&type=script&lang=js"
import style0 from "./Entity.vue?vue&type=style&index=0&id=c31a5b10&prod&lang=scss&scoped=true"
import style1 from "./Entity.vue?vue&type=style&index=1&id=c31a5b10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c31a5b10",
  null
  
)

export default component.exports